export function dataURItoBlob (dataURI) {
  const bytes = dataURI.split(',')[0].indexOf('base64') >= 0
    ? atob(dataURI.split(',')[1])
    : unescape(dataURI.split(',')[1])
  const mime = dataURI.split(',')[0].split(':')[1].split(';')[0]
  const max = bytes.length
  const ia = new Uint8Array(max)
  for (let i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i)

  return new Blob([ia], { type: mime })
}

export function blobToDataURL (blob) {
  return new Promise((resolve) => {
    const a = new FileReader()
    a.onload = function (e) {
      resolve(e.target.result)
    }
    a.readAsDataURL(blob)
  })
}

export function imgUrlToDataURL (url) {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest()
    xhr.onload = function () {
      const reader = new FileReader()
      reader.onloadend = (e) => {
        const memoryImg = new Image()
        memoryImg.onload = () => {
          resolve({
            data: reader.result,
            width: memoryImg.width,
            height: memoryImg.height
          })
        }
        memoryImg.onerror = () => {
          resolve({})
        }
        memoryImg.src = reader.result
      }
      reader.onerror = () => {
        resolve({})
      }
      reader.readAsDataURL(xhr.response)
    }
    xhr.onerror = () => {
      resolve({})
    }
    xhr.open('GET', url)
    xhr.responseType = 'blob'
    xhr.send()
  })
}

export function resizeImage (settings) {
  const file = settings.file
  const maxSize = settings.maxSize || 1920

  let saveType = settings.type || null
  if (!saveType) {
    // Attempt to read file if blob
    if (typeof file === 'object') {
      saveType = file.type
    }
    // Attempt to read file if is data URI
    else if (typeof file === 'string') {
      saveType = file.substring(file.indexOf(':') + 1, file.indexOf(';'))
    }
  }

  // If no save type could be specified, default to jpg
  if (!saveType) {
    saveType = 'image/jpeg'
  }

  const reader = new FileReader()
  const image = new Image()
  const canvas = document.createElement('canvas')

  const resize = () => {
    let width = image.width
    let height = image.height

    if (width > height) {
      if (width > maxSize) {
        height *= maxSize / width
        width = maxSize
      }
    }
    else {
      if (height > maxSize) {
        width *= maxSize / height
        height = maxSize
      }
    }

    canvas.width = width
    canvas.height = height
    canvas.getContext('2d').drawImage(image, 0, 0, width, height)
    const dataUrl = canvas.toDataURL(saveType)
    return dataURItoBlob(dataUrl)
  }

  return new Promise((resolve, reject) => {
    // String would typically be a datauri. Attempt to shrink it as it is
    if (typeof file === 'string') {
      image.onload = () => resolve(resize())
      image.onerror = () => {
        reject('Failed to create stream')
      }
      image.src = file
    }
    // If is normal file object, read it in then shrink it
    else {
      if (!file.type.match(/image.*/)) {
        reject('Not an image')
        return
      }

      // Don't resize GIF, will remove animated properties
      if (file.type === 'image/gif') {
        reject('GIF cannot be resized')
        return
      }

      reader.onload = (readerEvent) => {
        image.onload = () => resolve(resize())
        image.onerror = () => {
          reject('Failed to create stream')
        }
        image.src = readerEvent.target.result
      }
      reader.onerror = () => {
        reject('Failed to create stream')
      }
      reader.onabort = () => {
        reject('Failed to create stream')
      }
      reader.readAsDataURL(file)
    }
  })
}

export function imageDimensions (file) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = function () {
      resolve({
        width: img.width,
        height: img.height
      })
    }
    img.onerror = () => {
      reject('Failed to load image')
    }
    img.src = file
  })
}

export default {
  methods: {
    resizeImage,
    imageDimensions
  }
}
